var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconKakao = function SvgIconKakao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.134 0 0 2.488 0 5.56c0 1.973 1.298 3.705 3.248 4.694l-.66 2.476a.205.205 0 0 0 .193.27.2.2 0 0 0 .122-.046l2.836-1.927c.412.06.832.093 1.26.093C10.866 11.12 14 8.63 14 5.56 14 2.488 10.865 0 7 0Z",
    fill: "current"
  })));
};
export default SvgIconKakao;